'use client'

import { useState } from 'react'
import Link from 'next/link'
import { Menu, X, Heart } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { cn } from '@/lib/utils'

export function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-[var(--gray-200)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2 group">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[var(--primary)] to-[var(--accent)] flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
              <Heart className="w-6 h-6 text-white" />
            </div>
            <span className="text-xl font-bold text-[var(--gray-900)] hidden sm:inline">
              NurseConnect
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              href="#features"
              className="text-[var(--gray-700)] hover:text-[var(--primary)] transition-colors duration-200"
            >
              Features
            </Link>
            <Link
              href="#how-it-works"
              className="text-[var(--gray-700)] hover:text-[var(--primary)] transition-colors duration-200"
            >
              How It Works
            </Link>
            <Link
              href="#for-facilities"
              className="text-[var(--gray-700)] hover:text-[var(--primary)] transition-colors duration-200"
            >
              For Facilities
            </Link>
            <Link
              href="#about"
              className="text-[var(--gray-700)] hover:text-[var(--primary)] transition-colors duration-200"
            >
              About
            </Link>
          </div>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <Button variant="ghost" size="md">
              Sign In
            </Button>
            <Button variant="glow" size="md">
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-[var(--gray-100)] transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-[var(--gray-700)]" />
            ) : (
              <Menu className="w-6 h-6 text-[var(--gray-700)]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={cn(
          'md:hidden overflow-hidden transition-all duration-300 ease-in-out',
          mobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        )}
      >
        <div className="px-4 py-4 space-y-3 bg-white border-t border-[var(--gray-200)]">
          <Link
            href="#features"
            className="block px-3 py-2 rounded-lg text-[var(--gray-700)] hover:bg-[var(--gray-100)] hover:text-[var(--primary)] transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            Features
          </Link>
          <Link
            href="#how-it-works"
            className="block px-3 py-2 rounded-lg text-[var(--gray-700)] hover:bg-[var(--gray-100)] hover:text-[var(--primary)] transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            How It Works
          </Link>
          <Link
            href="#for-facilities"
            className="block px-3 py-2 rounded-lg text-[var(--gray-700)] hover:bg-[var(--gray-100)] hover:text-[var(--primary)] transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            For Facilities
          </Link>
          <Link
            href="#about"
            className="block px-3 py-2 rounded-lg text-[var(--gray-700)] hover:bg-[var(--gray-100)] hover:text-[var(--primary)] transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            About
          </Link>
          <div className="pt-4 space-y-2">
            <Button variant="ghost" size="md" className="w-full">
              Sign In
            </Button>
            <Button variant="glow" size="md" className="w-full">
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </nav>
  )
}
